import React, { Component } from 'react';
import { connect } from 'react-redux';

class ToolbarTemplateGuest extends Component {

    handleBack = () => {
        this.props.history.goBack();
    }
    render() {
        return (
            <React.Fragment>
                <div className='tiles-hello'>
                    <svg class="uig-svg-icon" viewBox="0 0 10 18" onClick={this.handleBack} ><path fill="#585B58" d="M9 18a.997.997 0 0 1-.707-.293l-8-8a.999.999 0 0 1 0-1.414l8-8a.999.999 0 1 1 1.414 1.414L2.414 9l7.293 7.293A.999.999 0 0 1 9 18"></path></svg>
                    <div className='title'>
                        Shutterfly Photo Tiles
                    </div>
                </div>
                {this.props.centralConfig.show_downtime_banner && <div className={'downtime-banner'}><img src='//cdn-image.staticsfly.com/i/home/error_md.png' alt='error_sybl' /><p>{this.props.centralConfig.show_downtime_banner_error}</p></div>}
                {this.props.children}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        centralConfig: state.app.centralConfig
    };
};

export default connect(mapStateToProps)(ToolbarTemplateGuest);
